<script>
    import wrappedFetch from "../../../wrappedFetch.js";
    import { onMount } from "svelte";
    import { ProviderName } from "../store.js";
    import Modal from "../../components/modal.svelte";
    import Button from "../../components/button.svelte";
    import Card from "../../components/card.svelte";
    import NoSetup from "../../components/nosetup.svelte";
    import ProviderImage from "./image.svelte";
    import HelpIcon from "../../components/helpIcon.svelte";

    let isButtonLoading=false;

    export let attendanceSchedules = [];
    export let optionsVM;
    export let isCloud = false;
    export let installKey="";
    export let estab ="";
    let showModal = false;
    let timeStr="";
    let simsTooltipText ="This data will typically be imported daily. Please check the schedule within the AutoUpdate software installed on your school’s server to see the full details.";
    let bromcomTooltipText="We suggest exporting data to us daily. The schedule for this is set within Bromcom.";
    let showSIMSInstallDetails=false;
    //let userDataImport="";
    
    const runImport = async () => {
        isButtonLoading = true; 
        let resp = await wrappedFetch(`/api/import/RunImport`, {
            method: "post",
        });
        let response = await resp.json();
        isButtonLoading = false;
        if (response.success) showModal = true;
    };
    onMount(()=>{
        // if(isCloud || $ProviderName =="integris g2" || $ProviderName == "pupilasset")
        // userDataImport="Daily";
        // else if($ProviderName == "bromcom")
        // userDataImport = `<span style="cursor:pointer;" class="material-icons-outlined" data-toggle="tooltip" data-placement="bottom" title="${bromcomTooltipText}">info</span>`;
        // else if($ProviderName == "sims")
        // userDataImport = `<span style="cursor:pointer;" class="material-icons-outlined" data-toggle="tooltip" data-placement="bottom" title="${simsTooltipText}">info</span>`;
        let len = attendanceSchedules.filter(a=>a.strScheduleTime !="").length; 
        let separator="";
        attendanceSchedules.forEach((a,i)=>
        {
        if(len>i)
        {           
            if(a.strScheduleTime !="" && i+2 < len)
            separator = ",";
           else if(a.strScheduleTime !="" && i+2 == len)
            separator=" and "
            else separator=""            
            timeStr += a.strScheduleTime !="" ? a.strScheduleTime+separator:"" ;
        }
        })       
    })
</script>

<svelte:head>
    <title>Import Configuration | Wavenet Nimbus</title>
</svelte:head>
<Modal bind:showModal={showSIMSInstallDetails} sizeClass="">
    <div slot="header"><h4>Install Details</h4></div>
    <div slot="content">
        <p>Importing data from SIMS relies on AutoUpdate software being installed and configured in your school. The unique license key that needs to be inputted in the software is below.<p>
            <p>School: <b>{estab}</b></p>
            <p>License key: <b>{installKey}</b></p>
        <p>For full instructions on configuring the software please <a href="https://nimbus.adept.education/user_guide/sims.html" target="_blank">click here</a>.</p>
    </div>
</Modal>
<Modal bind:showModal targetClass="runImport" sizeClass="">
    <div slot="header"><h4>Request Queued</h4></div>
    <div slot="content">
        <p>Your request to import data has been queued. User data will typically be processed overnight and attendance data within 15 minutes. </p>
        <p>Please note that running this import will not affect any schedules that are set up. </p>
    </div>
</Modal>

{#if $ProviderName == "" || (optionsVM && Object.entries(optionsVM).filter((k) => k[0] == "importStudents" && k[1] == null).length > 0)}
<NoSetup setupURL={"/app/import/step1"} image={"Import_Config.png"}>  
    <div slot="content">
        <p class="mt-3">Your school does not currently import data to us from your MIS. This is needed in order to use any services we integrate with.</p> <p style="">Please click the “Setup” button below to configure the import. If you get stuck at any point, please take a look at our <a href="https://nimbus.adept.education/user_guide/import.html" target="_blank">user guide</a> or speak to our support team.</p>
    </div>
</NoSetup>
    <!-- <Card>
        <div slot="header"><h3>Configuration</h3></div>
        <div slot="body">
            <p>Your school does not currently import data to us from your MIS. This is needed in order to use any services we integrate with.</p>
            <p style="margin-bottom: 0px;">Please click the “Setup” button below to configure the import. If you get stuck at any point, please take a look at our <a href="https://nimbus.adept.education/user_guide/import.html" target="_blank">user guide</a> or speak to our support team.</p>
        </div>
        <div slot="footer">
            <a class="btn btn-primary" href="/app/import/step1">Setup</a>
        </div>
    </Card> -->
{:else}
    <h1>Import Configuration</h1>
    <p>The import of data from your MIS is configured on this page. Account matching and the import history can be viewed on the <a href="/app/import/logs">logs</a> page.</p>
  {#if $ProviderName != "sims" && $ProviderName != "bromcom"}
    <div class="mb-3">
        <Button buttonClass={"btn-primary"} buttonText={"Import now"} bind:isLoading={isButtonLoading} on:click={runImport}/>
        <!-- <button class="btn btn-primary" on:click={runImport}>Import now</button> -->
        <!-- {#if optionsVM.showRunAttendance}
        <button class="btn btn-primary ml-3" data-toggle="modal" data-target=".runImport" on:click={runImport}>Run Attendance</button>
        {/if} -->
    </div>
    {/if}

    {#if $ProviderName == "sims"}
    <div class="mb-3">
        <Button buttonClass={"btn-grey"} buttonText={"Install Details"}  on:click={()=>showSIMSInstallDetails = true}/>       
    </div>
    {/if}

    <Card>
        <div slot="header" class="header">
            <h3>Data Source</h3>
            <div>
                <a
                    class="btn btn-default"
                    style="font-size:20px"
                    href="/app/import/step1"
                    ><i class="far fa-edit text-primary" /></a
                >
                <!-- <button class="btn btn-default" style="font-size:20px"
                    ><i class="far fa-question-circle text-primary" /></button
                > -->
            </div>
        </div>
        <div slot="body"><ProviderImage provider={$ProviderName} /></div>
    </Card>

    <br />
    <Card cardTable={true}
        ><div slot="header" class="header">
            <h3>Users</h3>
            <div>
                <a class="btn btn-default" style="font-size:20px" href="/app/import/step3" ><i class="far fa-edit text-primary" /></a>               
            </div>
        </div>
        <div slot="body">
            <table class="table">
                <tbody>
                    <tr>
                        <td style="border-top:none">Import staff?</td>
                        <td style="border-top:none">
                            {optionsVM && optionsVM.importStaff == 1
                                ? "Yes"
                                : "No"}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Import pupils?
                        </td>
                        <td>
                            {optionsVM && optionsVM.importStudents == 1
                                ? "Yes"
                                : "No"}
                        </td>
                    </tr>                
                 
                    {#if optionsVM.showContacts}
                        <tr>
                            <td>Import pupil contacts?</td>
                            <td>
                                {optionsVM && optionsVM.importContacts == 1
                                    ? "Yes"
                                    : "No"}
                            </td>
                        </tr>
                    {/if}
                    {#if optionsVM.showGroups}
                        <tr>
                            <td>Import pupil groups and classes?</td>
                            <td>
                                {optionsVM &&
                                optionsVM.importGroupsAndClasses == 1
                                    ? "Yes"
                                    : "No"}
                            </td>
                        </tr>
                    {/if}
                    <tr>
                        <td>When should user data be imported?</td>
                        <td>
                            {#if (isCloud || $ProviderName =="integris g2" || $ProviderName == "pupilasset")}
                                Daily
                            {:else if ($ProviderName == "bromcom")}
                                <HelpIcon message="{bromcomTooltipText}" />
                            {:else if ($ProviderName == "sims")}
                                <HelpIcon message="{simsTooltipText}" />
                            {/if}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div></Card
    >
    {#if optionsVM.showAttendance}
    <br />
    <Card cardTable={true}>
        <div slot="header" class="header">
            <h3>Attendance</h3>
            <div>
                <a
                    class="btn btn-default"
                    style="font-size:20px"
                    href="/app/import/step3"
                    ><i class="far fa-edit text-primary" /></a
                >
              
            </div>
        </div>
        <div slot="body">
            <table class="table">
                <tbody>                   
                    <tr>
                        <td style="border-top:none">Import pupil attendance?</td>
                        <td style="border-top:none">
                            {optionsVM && optionsVM.importAttendance == 1
                                ? "Yes"
                                : "No"}
                        </td>
                    </tr>
                    {#if optionsVM && optionsVM.importAttendance == 1 && optionsVM.showAttendanceSchedule}
                        <tr>
                            <td>When should attendance data be imported?</td>
                            <td>
                                Daily at {timeStr}
                            </td>
                        </tr>
                    {:else if ($ProviderName == "bromcom" || $ProviderName == "sims") && optionsVM.importAttendance == 1}
                    <tr>
                        <td>When should attendance data be imported?</td>
                        <td>
                            {#if (isCloud || $ProviderName =="integris g2" || $ProviderName == "pupilasset")}
                                Daily
                            {:else if ($ProviderName == "bromcom")}
                                <HelpIcon message="{bromcomTooltipText}" />
                            {:else if ($ProviderName == "sims")}
                                <HelpIcon message="{simsTooltipText}" />
                            {/if}
                        </td>
                    </tr>
                    {/if}
             
                </tbody>
            </table>
        </div>
    </Card>
{/if}
{/if}

<!-- <div class="card">
    <div class="card-body">
        There is no configuration set up. Please click 'Set' button below
        to set up the configuration.
    </div>
    <div class="card-footer">
        <a class="btn btn-primary" href="/import/3">Set</a>
    </div>
</div> -->

<style>
    tr td:first-child {
        width: 75%;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>
